<template>
  <div class="t-app__container">
    <heading :title="$t('create-gathering-title')" />
    <div class="h-section h-section--no-margin-top">
      <s-form @submit="createGathering">
        <div class="h-grid h-grid--justify-content-center h-grid--row-gutter">
          <div class="h-grid__col h-grid__col--12">
            <name-block v-model="$v.name.$model" :canEdit="true" :showError="$v.name.$dirty && !$v.name.required" />
          </div>

          <div class="h-grid__col h-grid__col--sm-10 h-grid__col--md-8">
            <p>{{ $t('gathering-create-links-detail') }}</p>
            <p>{{ $t('gathering-create-links-detail-documents') }}</p>
          </div>

          <div class="h-grid__col h-grid__col--sm-10 h-grid__col--md-8">
            <div class="m-form-group">
              <span class="a-form-checkbox a-form-checkbox--block">
                <input type="checkbox" id="agrees-to-conditions" v-model="$v.agreesToConditions.$model" />
                <label for="agrees-to-conditions">{{ $t('gathering-create-links-confirmation') }}</label>
              </span>
              <span v-if="$v.agreesToConditions.$dirty">
                <span class="m-form-group__error" v-if="!$v.agreesToConditions.isChecked">{{ $t('error-field-required') }}</span>
              </span>
            </div>
          </div>

          <div class="h-grid__col h-grid__col--sm-10 h-grid__col--md-8">
            <div class="m-form-ctrl">
              <span class="m-form-ctrl__item">
                <button class="a-btn-primary" type="submit">{{ $t('button-create-gathering') }}</button>
              </span>
              <span class="m-form-ctrl__item">
                <router-link :to="{ name: $consts.urls.URL_USER_ORGANIZE_DASHBOARD }">
                  {{ $t('return-login-btn') }}
                </router-link>
              </span>
            </div>
          </div>
        </div>
      </s-form>
    </div>

    <div class="t-app__confetti t-app__confetti--01"></div>
    <div class="t-app__dot t-app__dot--large"></div>
    <div class="t-app__confetti t-app__confetti--02"></div>
    <div class="t-app__confetti t-app__confetti--03"></div>
    <div class="t-app__confetti t-app__confetti--04"></div>
    <div class="t-app__dot t-app__dot--medium"></div>
    <div class="t-app__confetti t-app__confetti--05"></div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

import Heading from '@/components/heading'
import SForm from '@/components/form/form'
import NameBlock from '@/components/pages/gathering/edit-steps/name-block'

import GatheringService from '@/services/gathering'
import LoaderService from '@/services/loader'
import NotificationService from '@/services/notification'
import { URL_USER_ORGANIZE_DASHBOARD, URL_EDIT_GATHERING } from '@/consts/urls'

import i18n from '@/helpers/i18n'
import router from '@/router'

const isChecked = value => value === true

export default {
  components: {
    SForm,
    Heading,
    NameBlock
  },
  data() {
    return {
      name: '',
      latitude: '',
      longitude: '',
      postalcode: '',
      city: '',
      region: '',
      agreesToConditions: null
    }
  },
  async beforeRouteEnter(to, from, next) {
    LoaderService.showLoader()

    const gathering = await GatheringService.getMyGathering()

    next(vm => {
      LoaderService.hideLoader()
      if (gathering !== null) {
        router.push({ name: URL_USER_ORGANIZE_DASHBOARD })
      }
    })
  },
  validations: {
    name: {
      required
    },
    agreesToConditions: {
      isChecked
    }
  },
  methods: {
    createGathering: async function() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        let request = {
          name: this.name,
          latitude: this.latitude,
          longitude: this.longitude,
          postalcode: this.postalcode,
          city: this.city
        }

        LoaderService.showLoader()
        let myGathering = await GatheringService.createGathering(request)
        LoaderService.hideLoader()
        NotificationService.showSuccess(i18n.t('gathering-create-success-notification'))
        router.push({ name: URL_EDIT_GATHERING, params: { id: myGathering.Id } })
      }
    },
    setPlace(place) {
      this.longitude = place.geometry.location.lng()
      this.latitude = place.geometry.location.lat()
      let vm = this

      place.address_components.forEach(function(c) {
        switch (c.types[0]) {
          case 'locality':
            vm.city = c.long_name
            break
          case 'postal_code':
            vm.postalcode = c.long_name
            break
        }
      })
    }
  }
}
</script>

<style lang="scss"></style>
